var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"search-result-row"},[_c('div',{staticClass:"search-result-row-content"},[_c('div',{staticClass:"search-result-row-title",on:{"click":function($event){return _vm.onClickTitle(_vm.item)}}},[_vm._v(" "+_vm._s(_vm.item.title)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }